<div class="container-fluid">
  <div class="page-header">
    <h1>Tasks</h1>
  </div>

  <section class="tasks page-content">
    <div
      class="tasks__group-row"
      cdkDropListGroup
      cdkDropList
      [cdkDropListData]="groups()"
      (cdkDropListDropped)="dropGroup($event)"
      cdkDropListOrientation="horizontal"
    >
      @for (group of groups(); track group.id) {
        <div class="tasks__group" cdkDrag>
          <div class="tasks__group__header">
            <h2 class="tasks__group__header__title">
              <input
                type="text"
                [ngModel]="group.name"
                (ngModelChange)="onUpdateGroup(group.id, $event)"
              />
            </h2>
            <button
              (click)="toggleUpdateGroupColors(group.id, groupColorsActive)"
              class="tasks__group__header__color-label"
              [attr.data-color]="group.color"
            >
              &nbsp;
            </button>
            <dialog
              class="tasks__group__colors"
              id="group-{{ group.id }}-colors-dialog"
              closedby="any"
              [open]="groupColorsActive === group.id"
              (close)="toggleUpdateGroupColors(group.id)"
            >
              <h4 class="tasks__group__colors__title">Colors</h4>
              <ul class="tasks__group__colors__list">
                @for (color of availableColors; track color) {
                  <li
                    class="tasks__group__colors__list__item"
                    [attr.data-color]="color"
                  >
                    <input
                      type="radio"
                      name="group-{{ group.id }}-color"
                      id="{{ group.id }}-color-{{ color }}"
                      [value]="color"
                      [checked]="group.color === color"
                      (change)="handleGroupColorChange(group.id, color)"
                    />
                  </li>
                }
              </ul>
            </dialog>
          </div>

          <ul
            class="tasks__group__list"
            id="group-{{ group.id }}"
            cdkDropList
            [cdkDropListData]="group"
            (cdkDropListDropped)="dropTask($event)"
            [cdkDropListConnectedTo]="groupLists"
          >
            @for (task of group.tasks; track task.id) {
              <li class="tasks__group__list__item tasks__task" cdkDrag>
                <div class="tasks__task__inner">
                  <div
                    class="tasks__task__clickarea"
                    (click)="openDialog(task)"
                    (keypress)="openDialog(task)"
                    [tabindex]="$index"
                  >
                    &nbsp;
                  </div>
                  <div class="tasks__task__inner__header">
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      data-tooltip="Mark Completed"
                      [ngModel]="task.is_completed"
                      (ngModelChange)="
                        onUpdateTask(task.id, { is_completed: $event })
                      "
                    />
                    <h3 class="tasks__task__inner__header__title">
                      {{ task.name }}
                    </h3>
                  </div>

                  <!-- @for (label of task.labels; track label.id) {
                    <span class="label-chip">{{ label.name }}</span>
                   } -->
                </div>
                <div class="tasks__task__inner__footer">
                  <span>
                    @if (task.due_date) {
                      {{ task.due_date | date: 'MMM d' }}
                    } @else {
                      No Due Date
                    }
                  </span>
                  <div class="tasks__task__inner__footer__users">
                    @for (user of task.user_assignments; track user.id) {
                      <div class="tasks__task__inner__footer__users__user">
                        <app-user-preview [userId]="user.user" />
                      </div>
                    }
                  </div>
                </div>
              </li>
            }
            <li class="tasks__group__list__item">
              <form
                #taskForm="ngForm"
                class="tasks__group__list__task-form"
                (ngSubmit)="onCreateTask(taskForm, group.id)"
              >
                <input
                  type="text"
                  [id]="group.id + '-task-name'"
                  name="task"
                  placeholder="Task Name"
                  ngModel
                  #taskInput
                  #taskInputModel="ngModel"
                />
                <label for="name" class="element-hidden">Task Name</label>
                <button class="button-inline--neutral" type="submit">
                  &plus;
                </button>
              </form>
              @if (taskInputModel.invalid && taskInputModel.dirty) {
                <p class="form-feedback error">{{ createTaskForm.errors }}</p>
              }
            </li>
            <li class="tasks__group__list__item">
              <div class="tasks__group__footer">
                <button
                  (click)="taskInput.focus()"
                  class="button-inline--neutral"
                >
                  &plus; Add Task
                </button>
                <app-popover
                  [isOpen]="groupOptionsActive === group.id"
                  (popoverClosed)="unsetGroupOptionsActive(group.id)"
                  class="tasks__group__footer__popover"
                >
                  <button
                    (click)="onDeleteGroup(group.id)"
                    class="button-tonal--error"
                  >
                    Delete
                  </button>
                </app-popover>
                <button
                  (click)="setGroupOptionsActive(group.id)"
                  class="button-inline--neutral"
                >
                  •••
                </button>
              </div>
            </li>
          </ul>
        </div>
      }
      <div class="tasks__group">
        <form
          #groupForm="ngForm"
          (ngSubmit)="onCreateGroup(groupForm)"
          [class]="[
            'tasks__group__add-form',
            groupForm.invalid && groupForm.dirty && 'error',
          ]"
        >
          <label for="group" class="element-hidden">Group Name</label>
          <input
            type="text"
            id="group-name"
            name="group"
            placeholder="&plus; New Group"
            ngModel
          />
          <button class="button-solid--primary" type="submit">Add</button>
          @if (groupForm.invalid && groupForm.dirty) {
            <p class="form-feedback error">{{ groupForm.errors }}</p>
          }
        </form>
      </div>
    </div>
  </section>
</div>
